// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuSale_menu__1u44S","tab_lis":"MenuSale_tab_lis__1foVy","ico":"MenuSale_ico__2FOjc","tab_txt":"MenuSale_tab_txt__2Q8hk","active":"MenuSale_active__2Q0CY"};